import { capitalize } from 'lodash';
import { Col, FormGroup, Label } from 'twyne-new.ui'

import DetailsModal from '@/components/modals/DetailsModal';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatDateTime } from 'utils';

import { actionFormatter } from './ActionFormatter';
import { colorizeNumberFormatter } from './ColorizeNumberFormatter';
import { entityLinkFormatter } from './EntityLinkFormatter';

export default function DetailsEntity({ info }) {
  const { row } = getInfo(info)

  return <>
    <DetailsModal title='Bucket Transaction Details'>
      {COLUMNS.map(({ field, label, formatter }) => <DetailsModalItem key={field} data={row} field={field} label={label} formatter={formatter} />)}
    </DetailsModal>
  </>
}

function DetailsModalItem({ data, field, label, formatter }) {
  let value = data[field]

  if (formatter) {
    value = formatter(value)
  }

  if (field === 'publisher_name') {
    const { id, name } = data
    value = entityLinkFormatter('publishers', id, name)
  }

  if (field === 'allocation_name') {
    const { id, name } = data
    value = entityLinkFormatter('allocations', id, name)
  }

  return <Col size='6' key={field}>
    <FormGroup>
      <Label>{capitalize(label)}</Label>
      <span className='twy-text-base-accent'>{value}</span>
    </FormGroup>
  </Col>
}

const COLUMNS = [
  {
    label: "Id",
    field: "id",
    formatter: value => value || '--',
  },
  {
    label: "Date",
    field: "ref_date",
    formatter: value => value ? formatDateTime(value) : '--',
  },
  {
    label: "Action",
    field: "action",
    formatter: value => value ? actionFormatter(value) : '--',
  },
  {
    label: 'Publisher',
    field: 'publisher_name',
  },
  {
    label: "Allocation",
    field: "allocation_name",
  },
  {
    label: "SubId",
    field: "subid",
  },
  {
    label: "Transaction Value",
    field: "transaction_value",
    formatter: value => value ? colorizeNumberFormatter(value) : '--',
  },
  {
    label: "Original Value",
    field: "original_value",
    formatter: value => value ? colorizeNumberFormatter(value) : '--',
  },
  {
    label: "Previous Balance",
    field: "bucket_value",
    formatter: value => value ? colorizeNumberFormatter(value) : '--',
  },
  {
    label: "Pekey",
    field: "pekey",
    formatter: value => value || '--',
  },
  {
    label: "user ID",
    field: "user_id",
    formatter: value => value || '--',
  },
  {
    label: "User Session ID",
    field: "usession_id",
    formatter: value => value || '--',
  },
  {
    label: "Path Session ID",
    field: "path_session_id",
    formatter: value => value || '--',
  },
  {
    label: "Path Action ID",
    field: "path_action_id",
    formatter: value => value || '--',
  },
]
